export const event = {
    event: "Events",
    name: "Event Name",
    type: "Type",
    startDate: "Start Date",
    endDate: "End Date",
    interval: "Interval",
    resetHour: "Reset Hour",
    eventReward: "Event Reward",
    active: "Active",
    dateCreated: "DATE CREATED",
    true: "TRUE",
    false: "FALSE",
    edit: "Edit",
    delete: "Delete",
    submit: "Submit",
    close: "close",
    filter: "filter",
    createEvent: "Create Event",
    editEvent: "Edit Event",
    search: "Search",
    advanceFilter: "Advance Filter",
    subEvent: "Sub Event",
    createSubEvent: "Create Sub Event",
    editSubEvent: "Edit Sub Event",
    subName: "Name",
    providerName: "Provider",
    targetSettleAmount: "Target Settle Amount",
    targetSettleCount: "Target Settle Count",
    targetValidAmount: "Target Valid Amount",
    targetRoundCount: "Target Round Count",
    action: "Action",
    rewardName: "Name",
    description: "Description",
    rewardAmount: "Amount",
    rewardIsPercent: "IsPercent",
    rewardType: "Reward Type",
    imageUrl: "Image",
    createEventReward: "Create Reward",
    editEventReward: "Edit Reward",
    previewImage: "Preview Image",
    reward: "Reward",
    userEvent: "User Event",
    eventName: "Event Name",
    percent: "Percent",
    success: "Success",
    claim: "Claim",
    userSubEvent: "User Sub Event",
    settleAmount: "Settle Amount",
    settleCount: "Settle Count",
    validAmount: "Valid Amount",
    roundCount: "Round Count",
    subEventName: " Sub Event Name"
}